import {
  FetchFinCategoriesCacheKey,
  FetchFinCategoriesFilters,
  FetchFinCategoriesGqlQuery,
  FetchFinCategoriesLimit,
  FetchFinCategoriesPage,
  FetchFinCategoriesSort
} from '../../finCategoriesTypes';

import {
  FinCategoriesPermissions,
  INITIAL_FIN_CATEGORIES_FILTERS,
  INITIAL_FIN_CATEGORIES_LIMIT,
  INITIAL_FIN_CATEGORIES_PAGE,
  INITIAL_FIN_CATEGORIES_SORT
} from '../../finCategoriesConstants';
import { useCacheIndexQuery } from '../../../common/reactQuery/hooks/useCacheIndexQuery';

import { FetchCacheItemsSources } from '../../../../types';

interface PaginatedFinCategoriesOptions {
  cacheKey: FetchFinCategoriesCacheKey;
  initialFilters?: FetchFinCategoriesFilters;
  initialSort?: FetchFinCategoriesSort;
  initialPage?: FetchFinCategoriesPage;
  initialLimit?: FetchFinCategoriesLimit;
  options?: {
    enabled?: boolean;
    enabledPlaceholder?: boolean;
    withoutPrefetch?: boolean;
  };
  query: FetchFinCategoriesGqlQuery;
}

const scope = 'finCategories';

function useCachePaginatedFinCategories<FetchFinCategoriesInvoiceType>({
  cacheKey,
  initialFilters = INITIAL_FIN_CATEGORIES_FILTERS,
  initialSort = INITIAL_FIN_CATEGORIES_SORT,
  initialPage = INITIAL_FIN_CATEGORIES_PAGE,
  initialLimit = INITIAL_FIN_CATEGORIES_LIMIT,
  options,
  query
}: PaginatedFinCategoriesOptions) {
  const {
    changeItemsFilters,
    clearItemsFilters,
    currentFilters,
    currentLimit,
    currentPage,
    currentSort,
    data,
    filterItems,
    isFetched,
    isLoading,
    isPlaceholderData,
    items,
    itemsError,
    itemsErrorMessage,
    itemsTotalCount,
    limitItems,
    meta,
    paginateItems,
    prefetchItems,
    sortItems,
    updateItemCache
  } = useCacheIndexQuery<FetchFinCategoriesInvoiceType>({
    action: FinCategoriesPermissions.READ_FIN_CATEGORIES_INDEX_ES_QUERY,
    cacheKey,
    defaultApi: 'cache_api',
    initialFilters,
    initialLimit,
    initialPage,
    initialSort,
    scope,
    query,
    cacheQuery: query,
    options,
    source: FetchCacheItemsSources.DB
  });

  return {
    changeFinCategoriesFilters: changeItemsFilters,
    clearFinCategoriesFilters: clearItemsFilters,
    filterFinCategories: filterItems,
    finCategories: items,
    finCategoriesData: data,
    finCategoriesError: itemsError,
    finCategoriesErrorMessage: itemsErrorMessage,
    finCategoriesFetched: isFetched,
    finCategoriesFilters: currentFilters,
    finCategoriesIsPlaceholderData: isPlaceholderData,
    finCategoriesLimit: currentLimit,
    finCategoriesLoading: isLoading,
    finCategoriesMeta: meta,
    finCategoriesPage: currentPage,
    finCategoriesSort: currentSort,
    finCategoriesTotalCount: itemsTotalCount,
    limitFinCategories: limitItems,
    paginateFinCategories: paginateItems,
    prefetchFinCategories: prefetchItems,
    sortFinCategories: sortItems,
    updateInvoiceCache: updateItemCache
  };
}

export default useCachePaginatedFinCategories;
